<template>
  <c-view v-min-height>
    <c-page>
      <c-content>
        <div class="alpha-register">
          <div
            class="header bg-img"
            :class="[isMiniProgramModel ? 'bg-img--miniprogram' : '']"
          >
            <div class="header-desc">
              <img
                class="alpha-logo"
                src="../../assets/images/logo/logo.png"
                alt=""
              />
              <div class="text-desc">欢迎注册生意专家</div>
            </div>
          </div>
          <div class="content">
            <div class="register-form">
              <form action="">
                <div class="s-form-group">
                  <i class="s-icon s-icon-store prepend-icon"></i>
                  <input
                    type="text"
                    ref="J_shopName"
                    @blur="resetScroll"
                    v-model.trim="formData.storename"
                    class="prepend-icon"
                    placeholder="店铺名称（8个字以内）"
                  />
                </div>
                <div class="s-form-group">
                  <i class="s-icon s-icon-telephone prepend-icon"></i>
                  <input
                    type="phone"
                    ref="J_phone"
                    style="width: 50%"
                    @blur="handlerBlurPhone"
                    v-model.trim="formData.account"
                    class="prepend-icon"
                    placeholder="请输入手机号码"
                  />
                  <button class="code-btn" type="button" @click="getSmsCap">
                    {{ content }}
                  </button>
                </div>
                <div class="s-form-group">
                  <i class="s-icon s-icon-password prepend-icon"></i>
                  <input
                    type="text"
                    ref="smsCode"
                    @blur="resetScroll"
                    v-model.trim="formData.vercode"
                    style="width: 50%"
                    class="prepend-icon"
                    max="6"
                    placeholder="请输入短信验证码"
                  />
                </div>
                <div class="s-form-group">
                  <i class="s-icon s-icon-password prepend-icon"></i>
                  <input
                    type="password"
                    ref="J_pwd"
                    @blur="resetScroll"
                    v-model.trim="formData.password"
                    class="prepend-icon"
                    placeholder="请输入密码"
                  />
                </div>
              </form>
            </div>
            <div
              class="s-btn s-btn--orange"
              :class="[isMiniProgramModel ? 's-btn--miniprogram' : '']"
              @click="nextStep()"
            >
              下一步
            </div>
            <p class="mt-20 text-center text-color gray">
              点击下一步，即同意
              <a
                @click="goUserTerm()"
                class="text-color link"
                :class="[isMiniProgramModel ? 'link--miniprogram' : '']"
                >《生意专家用户协议》</a
              >
            </p>
          </div>
          <div class="footer-container">
            <info-footer></info-footer>
          </div>
        </div>
      </c-content>
      <c-dialog v-if="showDialog">
        <div slot="bd-content">
          <!-- <h3>请输入图形验证码</h3> -->
          <div class="dialog-content">
            <!-- <i class="s-icon s-icon-password prepend-icon"></i> -->
            <input
              type="text"
              ref="J_code"
              v-model.trim="inputImgCode"
              style="width: 60%; margin-right: 10px"
              class="prepend-icon"
              placeholder="请输入图形验证码"
            />
            <img @click="initCodePath" :src="codeImg" alt="" />
          </div>
          <!-- <div class="scroll-content"></div> -->
          <div class="btn-group" @click="() => (this.showDialog = false)">
            <div type="button">取消</div>
            <div type="button" @click="sendSms">确定</div>
          </div>
        </div>
      </c-dialog>
    </c-page>
    <router-view></router-view>
  </c-view>
</template>
<script>
import CDialog from '../components/c-dialog'
import InfoFooter from '../info-footer'
import RegisterModel from '../../model/agent-register-user/index'
import { mixinsDevice } from '../../mixins'
import debounce from 'lodash.debounce'
export default {
  name: 'AgentRegisterUser',
  mixins: [mixinsDevice],
  data () {
    return {
      showDialog: false,
      content: '发送验证码',
      totalTime: 120,
      canClick: true, // 添加canClick
      registerModel: new RegisterModel(),
      codeImg: '',
      codeToken: '',
      inputImgCode: null,
      formData: {
        realname: null,
        account: null,
        password: null,
        storename: null,
        vercode: null,
        rec: null,
        agc: null, // 四川电信注册专用
        source: null
      }
    }
  },
  components: { InfoFooter, CDialog },
  mounted () {
    const { regagentflag = '', empcode = '', recommend = '' } = this.$route.query
    this.formData.agc = empcode ? regagentflag + ',' + empcode : regagentflag + empcode
    this.formData.rec = recommend
    // 从router获取代理商参数
    // this.formData.regagentflag = this.$route.query.regagentflag ? this.$route.query.regagentflag : ''
    // this.formData.recommend = this.$route.query.recommend ? this.$route.query.recommend : null
    // this.formData.agt_emp_code = this.$route.query.empcode ? this.$route.query.empcode : null
  },
  methods: {
    countDown () {
      // if (!this.canClick) return
      this.canClick = false
      this.content = this.totalTime + 's后重新发送'
      let clock = window.setInterval(() => {
        this.totalTime--
        this.content = this.totalTime + 's后重新发送'
        if (this.totalTime < 0) {
          window.clearInterval(clock)
          this.content = '重新发送验证码'
          this.totalTime = 10
          this.canClick = true  // 这里重新开启
        }
      }, 1000)
    },
    getSmsCap () {
      if (!this.canClick) return
      const patternPhone = /^1[3458769]\d{9}$/
      if (!patternPhone.test(this.formData.account)) {
        this.$wejs.alert('请输入正确的手机号码！')
        return
      }
      this.initCodePath()
    },
    sendSms () {
      if (!this.inputImgCode) {
        return
      }
      const params = {
        captcha: this.inputImgCode,
        token: this.codeToken,
        phone: this.formData.account
      }
      this.registerModel.getSmScode(params).then(res => {
        if (res.code === 200) {
          if (res.data.stat === '0000') {
            this.$wejs.toast(res.data.desc)
            this.countDown()
          } else {
            this.$wejs.toast(res.data.desc, {
              className: 's-toast-error'
            })
          }
        }
      })
    },
    /**
     * 输入完成手机号之后进行检测此手机号是否已经注册过
     */
    async handlerBlurPhone () {
      this.resetScroll()
    },
    /**
     * 用户协议
     */
    goUserTerm () {
      this.$router.push({ path: '/sign-up/user-term' })
    },
    /**
     * 初始化验证码地址
     */
    async initCodePath () {
      console.log(123)
      const data = await this.registerModel.getImgCode()
      this.codeImg = 'data:image/png;base64,' + data.image
      this.codeToken = data.token
      this.showDialog = true
      console.log(this.showDialog)
    },
    // 下一步
    nextStep: debounce(async function () {
      if (this._checkParams()) {
        // let loadingInstance = this.$wejs.loading('数据提交中')
        this.formData.source = this.$route.query.source
        if (!this.formData.agc) this.$route.query.agc
        this.registerModel.confirmReg(this.formData).then(res => {
          if (res.code === 200) {
            if (res.data.stat === '0000') {
              this.$wejs.alert('恭喜您，已经成功注册生意专家', () => {
                if (this.isMiniProgramModel) {
                  // eslint-disable-next-line no-undef
                  wx.miniProgram.navigateBack()
                } else {
                  window.location.href = 'http://www.i200.cn/mobile/download.aspx?from=regmobileweb'
                }
              })
            } else {
              this.$wejs.alert(res.data.desc)
            }
          }
        })
      }
    }, 300),
    /**
     * 检测参数是否合法
     * @private
     * @return {boolean} 检测结果
     */
    _checkParams () {
      // 验证参数
      if (!this.formData.storename) {
        this.$wejs.alert('请输入店铺名称', () => {
          this.$refs.J_shopName.focus()
        })
        return false
      } else
        if (this.formData.storename.length > 8 || this.formData.storename.length < 2) {
          this.$wejs.alert('店铺名称支持2到8位', () => {
            this.$refs.J_shopName.focus()
          })
          return false
        }
      if (!this.formData.account) {
        this.$wejs.alert('请输入手机号码', () => {
          this.$refs.J_phone.focus()
        })
        return false
      } else if (!(/^((1)+\d{10})$/.test(this.formData.account))) {
        this.$wejs.alert('请输入正确的手机号码', () => {
          this.$refs.J_phone.focus()
        })
        return false
      } else if (!this.formData.password) {
        this.$wejs.alert('请输入密码', () => {
          this.$refs.J_pwd.focus()
        })
        return false
      } else if (!(/^[a-z0-9]{6,12}$/.test(this.formData.password))) {
        this.$wejs.alert('请输入6-12位数字或字母密码', () => {
          this.$refs.J_pwd.focus()
        })
        return false
      } else if (!this.inputImgCode) {
        this.$wejs.alert('请输入验证码', () => {
          this.$refs.J_code.focus()
        })
        return false
      } else if (this.inputImgCode.length !== 4) {
        this.$wejs.alert('请输入合法的验证码', () => {
          this.$refs.J_code.focus()
        })
        return false
      } else if (!this.formData.vercode) {
        this.$wejs.alert('请输入短信验证码', () => {
          // this.$refs.smScode.focus()
        })
        return false
      } else if (this.formData.vercode.length !== 6) {
        this.$wejs.alert('请输入合法的短信验证码', () => {
          // this.$refs.smScode.focus()
        })
        return false
      } else {
        return true
      }
    },
    /**
     * 检测手机号是否合法，服务于发送验证码
     * @return {boolean}
     * @private
     */
    _checkPhone () {
      if (!this.formData.account) {
        return false
      } else if (!(/^((1)+\d{10})$/.test(this.formData.account))) {
        return false
      } else {
        return true
      }
    },
    // ios 兼容，input失去焦点后界面上移不恢复的问题
    resetScroll () {
      setTimeout(() => {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    }
  },
  computed: {
    codeImgPath () {
      if (this.formData.flowId) {
        return `http://webapi.i200.cn/v0/albert/security/verify-codeFlowId?flowId=${this.formData.flowId}`
      }
      return null
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./index";
</style>



// WEBPACK FOOTER //
// index.vue?157b4410